export default __webpack_public_path__ + "static/media/yogurtparfait-wide@2x.40d9dea1.jpg";